import { getAppById } from '@/registry/apps'

/**
 * Onboarding deep-link helpers.
 *
 * When a friend is sent an app URL (e.g. /apps/sharon) while logged out, the
 * middleware bounces them to /login?next=/apps/sharon. The auth pages read that
 * `next` target to (a) return the user to where they were headed and (b) infer
 * which app they came for, so a brand-new signup can start scoped to just that
 * app. Works for every registered app, not just sharon.
 */

/** Only honor internal, same-origin relative paths (open-redirect guard). */
export function sanitizeNext(next: string | null | undefined): string | null {
  if (!next) return null
  if (!next.startsWith('/')) return null
  // Reject protocol-relative ("//evil.com") and backslash tricks.
  if (next.startsWith('//') || next.startsWith('/\\')) return null
  return next
}

/**
 * If `next` points at an app landing page (/apps/<id>) for a real registered
 * app, return that app id — otherwise null.
 */
export function appIdFromNext(next: string | null | undefined): string | null {
  const safe = sanitizeNext(next)
  if (!safe) return null
  const match = safe.match(/^\/apps\/([^/?#]+)/)
  if (!match) return null
  return getAppById(match[1]) ? match[1] : null
}
